import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconSnowHard({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4754 8.14137C22.4235 8.14137 22.3735 8.1486 22.3216 8.15057C21.7455 5.71546 19.5629 3.90112 16.9522 3.90112C14.2067 3.90112 11.9373 5.90288 11.5079 8.52476C11.1653 8.4294 10.8043 8.37482 10.4327 8.37482C8.53288 8.37482 6.94542 9.70121 6.54099 11.4781C5.05349 12.0607 4 13.5035 4 15.1955C4 17.4018 5.79 19.1905 7.99562 19.1905H22.4761C25.5281 19.1905 28 16.7185 28 13.6679C28 10.6173 25.5281 8.14202 22.4761 8.14202L22.4754 8.14137Z"
        fill="white"
      />
      <path
        d="M10.0741 23.0809C10.5437 22.6114 10.5437 21.8501 10.0741 21.3805C9.60455 20.9109 8.84323 20.9109 8.37366 21.3805C7.9041 21.8501 7.9041 22.6114 8.37366 23.0809C8.84323 23.5505 9.60455 23.5505 10.0741 23.0809Z"
        fill="white"
      />
      <path
        d="M15.218 23.3997C15.8645 23.2483 16.2659 22.6014 16.1145 21.9548C15.9631 21.3082 15.3162 20.9068 14.6696 21.0582C14.0231 21.2097 13.6216 21.8566 13.7731 22.5031C13.9245 23.1497 14.5714 23.5511 15.218 23.3997Z"
        fill="white"
      />
      <path
        d="M11.9092 27.3764C12.5552 27.2226 12.9542 26.5743 12.8004 25.9282C12.6467 25.2822 11.9983 24.8832 11.3523 25.037C10.7063 25.1908 10.3072 25.8391 10.461 26.4851C10.6148 27.1312 11.2632 27.5302 11.9092 27.3764Z"
        fill="white"
      />
      <path
        d="M18.1931 27.0573C18.6627 26.5877 18.6627 25.8264 18.1931 25.3568C17.7236 24.8872 16.9622 24.8872 16.4927 25.3568C16.0231 25.8264 16.0231 26.5877 16.4927 27.0573C16.9623 27.5268 17.7236 27.5268 18.1931 27.0573Z"
        fill="white"
      />
      <path
        d="M21.4139 23.1635C21.9245 22.7389 21.9943 21.9808 21.5698 21.4702C21.1452 20.9596 20.3871 20.8898 19.8765 21.3143C19.3659 21.7388 19.2961 22.497 19.7206 23.0076C20.1451 23.5182 20.9033 23.588 21.4139 23.1635Z"
        fill="white"
      />
    </svg>
  );
}
